<template>
    <div class="card-inner">
        <div v-if="item.thumbnail" class="card-image">
            <picture>
                <source v-if="item.thumbnail && item.thumbnail.media_webp_small_url"
                    :srcset="item.thumbnail.media_webp_small_url" type="image/webp">
                <img loading="lazy" :src="item.thumbnail.media_small_url" :alt="item.meta.title">
            </picture>
            <picture>
                <source v-if="item.thumbnail_2 && item.thumbnail_2.media_webp_small_url"
                    :srcset="item.thumbnail_2.media_webp_small_url" type="image/webp">
                <img loading="lazy" v-if="item.thumbnail_2" :src="item.thumbnail_2.media_small_url" :alt="item.meta.title"
                    class="image-hover">
            </picture>
        </div>
        <div class="card-info">
            <div class="card-info-text">
                <span v-if="item.brand_obj" class="card-brand">
                    {{ item.brand_obj.meta.title }}
                </span>
                <div class="card-title">
                    {{ item.meta.title }}
                </div>
                <div class="card-price-row">
                    <span v-if="item.type == 'variety' && item.default_child" class="card-price">
                        {{ trans('home.from') }} {{
                            (Math.round(Number(item.price_range_veriety.min))).toLocaleString('uk') }} ₴
                    </span>
                    <span v-else-if="item.type == 'variety' && !item.default_child" class="card-price">
                        {{ (Math.round(Number(item.price_range_veriety.min))).toLocaleString('uk') }} - {{
                            (Math.round(Number(item.price_range_veriety.max))).toLocaleString('uk') }} ₴
                    </span>
                    <template v-else>
                        <span v-if="item.sale_counted > 0">
                            <span class="card-price">
                                - {{ item.sale_counted }} %
                            </span>
                            <span class="card-price-prev">
                                {{ Math.round(item.price) }} ₴
                            </span>
                        </span>
                        <span class="card-price">
                            {{ (Math.round(item.price_finaly)).toLocaleString('uk') }} ₴
                        </span>
                    </template>
                </div>
            </div>
            <div class="card-buttons">
                <a :href="item.slug_suffix" type="button" class="btn-round-outlined-large">
                    <svg class="icon">
                        <use xlink:href="/img/front/icons/svgmap.svg#eye" />
                    </svg>
                </a>
                <add_to_cart :translations="null" :item="item" :type="2">
                </add_to_cart>
            </div>
        </div>
        <a :href="item.slug_suffix" class="card-link" :title="item.meta.title"></a>
        <productRemains v-if="access_to_remains" :remains="item.remains_manager" />
    </div>
</template>

<script>
import productRemains from './ProductRemains';

export default {
    components: {
        productRemains
    },
    props: {
        item: {
            required: true
        }
    },
    data() {
        return {
            access_to_remains: window.globalVariables.access_to_remains
        }
    }
}
</script>
